module.exports = __webpack_public_path__ + "img/powerbank.df25a91b.jpg";